// extracted by mini-css-extract-plugin
export default {"home_container":"home_home_container__XD6N9","action_btn":"home_action_btn__MAGke","loderVisible":"home_loderVisible__+533c"};